// Builds an authenticated absolute URL for a media asset's bytes.
// <img>/<video> element loads can't send an Authorization header, so the
// backend also accepts the JWT as a ?token= query param for these requests.

const API_BASE = (process.env.REACT_APP_API_URL || 'http://localhost:8080').replace(/\/$/, '');

/** @param relativeUrl e.g. "/api/media/5/content" (the `url` field on a MediaResponse) */
export function mediaSrc(relativeUrl: string): string {
  const token = localStorage.getItem('token') || '';
  const sep = relativeUrl.includes('?') ? '&' : '?';
  return `${API_BASE}${relativeUrl}${sep}token=${encodeURIComponent(token)}`;
}

/**
 * Authenticated absolute URL for a subject's syllabus document. Same token-in-query trick as
 * mediaSrc so a plain anchor/new-tab open carries the JWT.
 * @param relativeUrl e.g. "/api/kids/3/subjects/7/syllabus" (the `syllabusUrl` on a SubjectResponse)
 */
export function syllabusSrc(relativeUrl: string): string {
  return mediaSrc(relativeUrl);
}
